import * as React from 'react';

import AcademicTermsCard from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/AcademicTermsCard';
import { TermStatus } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/lib/academicTermTypes';
import type { DegreePlan_TermPlanFragment as TermPlan } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/learnerPlanFragment';
import { getCreditSummaryForCourses } from 'bundles/degree-home/components/v3-dpm/lib/gradeUtils';
import { getPlannedSegCoursesFromTermPlan } from 'bundles/degree-home/components/v3-dpm/lib/termsUtils';

type Props = {
  futureTermPlans: TermPlan[];
};

const FutureTerms: React.VFC<Props> = ({ futureTermPlans }) => {
  return (
    <React.Fragment>
      {futureTermPlans.map((termPlan) => {
        const plannedCourses = getPlannedSegCoursesFromTermPlan(termPlan);
        const { planned: plannedCredits } = getCreditSummaryForCourses(plannedCourses);
        return (
          <AcademicTermsCard
            key={termPlan.estimatedTermId}
            estimatedTermId={termPlan.estimatedTermId}
            explicitTermId={termPlan.linkedTerm?.id}
            termName={termPlan.estimatedTermName}
            courses={plannedCourses}
            termStatus={TermStatus.NOT_STARTED}
            creditSummary={{ completed: 0, inProgress: 0, planned: plannedCredits }}
            isTermPlanAutoCorrected={termPlan.autoCorrected}
          />
        );
      })}
    </React.Fragment>
  );
};

export default FutureTerms;
